import { useRecoilState } from 'recoil';
import { Redirect, useHistory } from 'react-router-dom';
import {
  MenuTree,
  MenuTreeChild,
  MenuTreeParent
} from '../../topicPath/const/MenuTree';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import {
  accessibleMenuTreeId,
  btnColor,
  userPlanId
} from '../../../GlobalState';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
  createStyles,
  makeStyles,
  withStyles
} from '@material-ui/core';
import { log } from '../../../utils';
import { faqLink } from '../../../const/Const';
import React, { useState } from 'react';

type Anchor = 'left';
// 開閉状態は呼び出し元で管理する
type toggleProps = {
  isOpen: boolean;
  setIsOpen: (status: boolean) => void;
};

const MenuTreeComponent: React.FC<toggleProps> = props => {
  // スタイル
  const [buttonColor] = useRecoilState(btnColor);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      list: {
        width: 320
      },
      listWrapper: {
        paddingTop: 0,
        paddingBottom: 100
      },
      paper: {
        background: buttonColor,
        marginTop: 64
      },
      typography: {
        padding: 10
      },
      backdrop: {
        zIndex: 10000,
        color: '#fff'
      },
      listTitle: {
        backgroundColor: '#333333',
        pointerEvents: 'none'
      },
      listTitleText: {
        color: '#FFFFFF'
      },
      listItemText: {
        color: '#FFFFFF',
        paddingLeft: 36
      }
    })
  );

  // アクセス可能なメニューリスト
  const [accessibleMenuTree] = useRecoilState<any>(accessibleMenuTreeId);
  const classes = useStyles();
  const history = useHistory();
  const [userPlan] = useRecoilState<any>(userPlanId);

  // メニュークローズ時、キーボード入力時のイベント
  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      props.setIsOpen(open);
    };

  const StyledListItem = withStyles(theme => ({
    root: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }))(ListItem);

  const list = (parentMenu: MenuTreeParent) => (
    <>
      {accessibleMenuTree.some((id: string) => id === parentMenu.menuId) && (
        <>
          <StyledListItem button className={classes.listTitle}>
            <ListItemIcon style={{ minWidth: 36 }}>
              {parentMenu.icon}
            </ListItemIcon>
            <ListItemText
              className={classes.listTitleText}
              primary={parentMenu.name}
            />
          </StyledListItem>
          {parentMenu.childMenu.map(menu => chiledMenuTree(menu))}
        </>
      )}
    </>
  );

  const chiledMenuTree = (childMenu: MenuTreeChild) => (
    <>
      {accessibleMenuTree.includes(childMenu.menuId) && (
        <StyledListItem
          button
          onClick={() => {
            if (userPlan !== undefined) {
              if (!childMenu.urls.includes(history.location.pathname)) {
                log.info(`to ${childMenu.urls[0]}`);
                history.push(childMenu.urls[0]);
              }
            }
          }}
        >
          <ListItemText
            className={classes.listItemText}
            primary={childMenu.name}
          />
        </StyledListItem>
      )}
    </>
  );

  const othersTree = () => (
    <>
      <StyledListItem button className={classes.listTitle}>
        <ListItemIcon style={{ minWidth: 36 }}>
          <MoreHorizOutlinedIcon style={{ color: 'fff' }} />
        </ListItemIcon>
        <ListItemText className={classes.listTitleText} primary={'その他'} />
      </StyledListItem>
      <StyledListItem
        button
        onClick={() => {
          window.open(faqLink.terms_of_service, '_blank');
        }}
      >
        <ListItemText className={classes.listItemText} primary={'利用規約'} />
      </StyledListItem>
      <StyledListItem
        button
        onClick={() => {
          window.open(faqLink.release_note, '_blank');
        }}
      >
        <ListItemText
          className={classes.listItemText}
          primary={'リリースノート'}
        />
      </StyledListItem>
      <>
        {/* 一時コメントアウト 追加開発用に残しておく */}
        {/* <StyledListItem
          button
          onClick={() => {
            if (userPlan !== undefined) {
              if (history.location.pathname !== "working_budget") {
                log.info(`to working_budget`);
                history.push("working_budget");
              }
            }
          }}
        >
          <ListItemText className={classes.listItemText} primary={"実行予算"} />
        </StyledListItem> */}
      </>
    </>
  );

  return (
    <>
      {(['left'] as Anchor[]).map(anchor => (
        <React.Fragment key={anchor}>
          <Drawer
            classes={{ paper: classes.paper }}
            anchor={anchor}
            open={props.isOpen}
            onClose={toggleDrawer(false)}
          >
            <div
              className={classes.list}
              role='presentation'
              onClick={toggleDrawer(false)}
              onKeyDown={toggleDrawer(false)}
            >
              <List className={classes.listWrapper}>
                {MenuTree.map(menu => list(menu))}
                {othersTree()}
              </List>
            </div>
          </Drawer>
        </React.Fragment>
      ))}
    </>
  );
};

export default MenuTreeComponent;
